import { CSSProperties, FC, ReactNode } from 'react';

export interface ISkeletonProps {
  variant?: 'container' | 'item';
  width?: string | number;
  height?: string | number;
  margin?: string | number;
  borderRadius?: string | number;
  style?: CSSProperties;
  animate?: boolean | 'v2';
  children?: ReactNode;
}

const Skeleton: FC<ISkeletonProps> = ({
  variant = 'container',
  width,
  height,
  margin,
  borderRadius,
  style = {},
  animate = false,
  children
}) => {
  const commonStyles: CSSProperties = {
    width,
    height,
    margin,
    borderRadius
  };

  const stylesContainerSkeleton: CSSProperties = {
    ...commonStyles,
    background: '#303030'
  };

  const stylesItemSkeleton: CSSProperties = {
    ...commonStyles,
    background: '#404040'
  };

  if (variant === 'item' && animate) {
    if (animate === 'v2') {
      return (
        <div className="animation-skeleton-item animation-skeleton-item--v2" style={{ ...commonStyles, ...style }}>
          {children}
        </div>
      );
    }

    return (
      <div className="animation-skeleton-item-wrapper">
        <div className="animation-skeleton-item" style={{ ...commonStyles, ...style }}>
          {children}
        </div>
      </div>
    );
  }

  const stylesSkeleton = variant === 'container' ? stylesContainerSkeleton : stylesItemSkeleton;

  return <div style={{ ...stylesSkeleton, ...style }}>{children}</div>;
};

export default Skeleton;
